(function(app) {
    const elements = {
        discountSliderEl: null,
        discountSliderTicksEl: null,
        selectedQuantityEl: null,
        selectedPercentEl: null,
    };

    app.DiscountSlider = {
        init: function() {
            elements.discountSliderEl = document.querySelector('.wdpp-discount-slider');
            elements.discountSliderTicksEl = document.querySelectorAll('.wdpp-discount-tick');
            elements.selectedQuantityEl = document.querySelector('.wdpp-selected-quantity');
            elements.selectedPercentEl = document.querySelector('.wdpp-selected-percent');
            
            const discounts = app.Store.getState('discounts');
            
            // Validate required elements and data
            if (!app.Utils.validateElements('discount slider inputs', {
                'discounts data': discounts,
                'discount slider': '.wdpp-discount-slider',
                'discount slider ticks': elements.discountSliderTicksEl,
                'selected quantity element': '.wdpp-selected-quantity',
                'selected percent element': '.wdpp-selected-percent'
            })) {
                return;
            }

            // Subscribe to cart quantity changes
            app.Store.subscribe('quantity', (value) => {
                // if (cartData && cartData.quantity && !cartData.fromDiscount) {
                    const index = app.Utils.getClosestDiscount(value);
                    this.updateDiscountDisplay(index, false);
                    elements.selectedQuantityEl.textContent = value;
                // }
            });

            // Set initial discount state
            const initialIndex = parseInt(elements.discountSliderEl.value) || 0;
            const discountData = discounts[initialIndex];
            if (discountData) {
                app.Store.subscribe('initialzied', () => {
                    app.Store.setState('discount', discountData);
                });
            }

            elements.discountSliderEl.addEventListener('input', () => {
                const index = parseInt(elements.discountSliderEl.value);
                this.updateDiscountDisplay(index, true);
            });
        },

        updateSliderFill: function(value) {
            if (!elements.discountSliderEl) {
                return;
            }
            const max = parseInt(elements.discountSliderEl.max);
            const percentage = (value / max) * 100;
            elements.discountSliderEl.style.setProperty('--slider-fill', `${percentage}%`);
        },
        
        updateDiscountDisplay: function(index, triggerCartChange) {
            const discounts = app.Store.getState('discounts');
            const data = discounts[index];
            if (!data) {
                return;
            }

            // Only update DOM elements if they exist
            if (elements.discountSliderEl) {
                elements.discountSliderEl.value = index;
            }
            if (elements.selectedQuantityEl) {
                elements.selectedQuantityEl.textContent = data.quantity;
            }

            const discount = parseFloat(data.discount) || 0;
            const maxDiscount = Math.max(...discounts.map(d => parseFloat(d.discount) || 0));
            const greenIntensityMax = 200;
            const greenIntensity = Math.round((discount / maxDiscount) * greenIntensityMax / 2);

            const isDarkMode = document.body.classList.contains('dark-mode');
            let newColor;

            if (discount > 0) {
                if (isDarkMode) {
                    newColor = `rgb(${Math.min(100, greenIntensity)}, ${Math.min(255, greenIntensityMax + greenIntensity)}, ${Math.min(100, greenIntensity)})`;
                } else {
                    newColor = `rgb(0, ${Math.min(greenIntensityMax, greenIntensityMax / 2 + greenIntensity)}, 0)`;
                }
            } else {
                newColor = 'var(--text-color)';
            }

            if (elements.selectedPercentEl) {
                elements.selectedPercentEl.textContent = discount > 0 ? '-' + discount + '%' : '';
                elements.selectedPercentEl.style.color = newColor;
            }

            if (elements.discountSliderTicksEl) {
                elements.discountSliderTicksEl.forEach((tick, i) => {
                    if (i <= index) {
                        tick.classList.add('active');
                    } else {
                        tick.classList.remove('active');
                    }
                });
            }

            this.updateSliderFill(index);

            // Update store
            app.Store.setState('discount', {
                ...data,
                color: newColor,
                triggerCartChange: triggerCartChange
            });
        },

        /**
         * Get the discount data for cart export
         * @returns {object} The discount data for the cart
         */
        getCartData: function() {
            // Return empty data if discount slider elements don't exist
            if (!elements.discountSliderEl) {
                return {};
            }
            
            const index = parseInt(elements.discountSliderEl.value) || 0;
            const discounts = app.Store.getState('discounts');
            const currentDiscount = discounts[index];
            return {
                discountIndex: index,
                discount: currentDiscount ? {
                    quantity: currentDiscount.quantity,
                    percentage: currentDiscount.discount
                } : null
            };
        }
    };
})(window.app = window.app || {});